import React from "react";

export const HelpInfo = () => {
  return (
    <div className="w-full px-8 py-10 bg-slate-50 text-[#14141f]">
      <h3 className="text-xl font-semibold mt-10 mb-4">
        Umowa zlecenia w WeExpert – prosty przewodnik
      </h3>
      <p>Ostatnia aktualizacja: 9 września 2025 r.</p>
      <p>
        Administrator serwisu / wystawca umów: WEEXPERT SP. Z O.O., ul. Marsz. Józefa Piłsudskiego 74/320, 50‑020 Wrocław, KRS: 0000986528, NIP: 9671458021, REGON: 52278693000000, kapitał zakładowy: 106 700 zł.
      </p>
      <div>
        <h3 className="text-xl font-semibold mt-10 mb-4">
          O czym jest ten artykuł?
        </h3>
        <p>
          Wyjaśniamy, kiedy w WeExpert zawierasz umowę zlecenia, kto może z niej skorzystać, jak potwierdzić status studenta lub status osoby zatrudnionej, jakie dokumenty dodać i jak wygląda cały proces rozliczenia z
        </p>

        <ol className="list-decimal ml-6">
          <li>
            <strong>
              Umowa zlecenia vs umowa o dzieło – szybkie rozróżnienie
            </strong>
            <ul className="list-disc ml-6 mt-2">
              <li>
                <strong>Umowa o dzieło</strong> – rozliczenie za efekt
                (konkretny rezultat jest z góry określony).
                <br />
                Przykład: „Stwórz 7 grafik na social media” → dzieło.
              </li>
              <li>
                <strong>Umowa zlecenia</strong> – rozliczenie za czas / staranne
                działanie, brak z góry określonej liczby rezultatów.
                <br />
                Przykład: „Obsługa graficzna profilu przez miesiąc” → zlecenie.
              </li>
            </ul>
            <p>
              W WeExpert standardowo rozliczamy prace jako umowę o dzieło, ale w
              uzasadnionych przypadkach stosujemy umowę zlecenia.
            </p>
          </li>

          <li>
            <strong>Kto może korzystać z umowy zlecenia w WeExpert?</strong>
            <p>
              Umowę zlecenia mogą rozliczać freelanserzy, którzy spełniają jeden
              z warunków:
            </p>
            <ol className="list-decimal ml-6">
              <li>
                Status osoby zatrudnionej w profilu WeExpert – pracujesz na
                umowę o pracę lub umowę zlecenia i otrzymujesz wynagrodzenie ≥
                minimalne wynagrodzenie za pracę.
              </li>
              <li>
                Status studenta w profilu WeExpert – masz mniej niż 26 lat i
                jesteś uczniem/studentem (studia podyplomowe nie dają statusu
                studenta).
              </li>
            </ol>
            <p>
              Osoby mieszkający poza Polska 
              Jeśli spełniasz 1 i 2  warunki, wybierz status studenta – zazwyczaj jest korzystniejszy kosztowo
            </p>
          </li>

          <li>
            <strong>Jak wygląda proces rozliczenia przez WeExpert?</strong>
            <ol className="list-decimal ml-6">
              <li>
                Wypełnij formularz: „Jednorazowa Umowa”, „Podpisz umowę” albo
                sprawdź ofertę w ogłoszeniu (WeExpert Jobs).
              </li>
              <li>WeExpert wysyła klientowi e‑mail z fakturą pro forma.</li>
              <li>
                Klient opłaca wynagrodzenie → w tym momencie między WeExpert a
                freelanserem zawierana jest umowa (dzieło albo zlecenie – w
                zależności od rodzaju pracy).
              </li>
            </ol>
          </li>

          <li>
            <strong>Status studenta – jak aktywować</strong>
            <p>
              <strong>Kto?</strong> Uczniowie i studenci (oprócz podyplomowych)
              do 26. roku życia.
            </p>
            <p>
              <strong>Co przygotować?</strong>
            </p>
            <ul className="list-disc ml-6">
              <li>
                skan/zdjęcie legitymacji uczniowskiej/studenckiej (obie strony)
                i zaświadczenie z uczelni.
              </li>
            </ul>
            <p>
              <strong>Jak dodać dokumenty?</strong>
            </p>
            <ul className="list-disc ml-6">
              <li>
                Zaloguj się → Moje dokumenty → Moje dokumenty →Wiza → Dodaj legitymację.
              </li>
              <li>Dodaj skany i zaznacz w Kwestionariusz że jesteś Studentem do 26 lat.</li>
            </ul>
            <p>
              <strong>Co dalej?</strong>
            </p>
            <ul className="list-disc ml-6">
              <li>
                Po weryfikacji otrzymasz e‑mail i w profilu zobaczysz status Aktywny + termin ważności (np. do końca semestru).
              </li>
              <li>
                Przed upływem ważności przypomnimy e‑mailem – dodaj nową legitymację/zaświadczenie.
              </li>
              <li>
               Jeśli dokument nie przejdzie weryfikacji – dostaniesz e‑mail z powodem i prośbą o wyjaśnienia.
              </li>
              <li>
                Uwaga: Status studenta tracisz w dniu obrony (licencjat/magister), nawet jeśli legitymacja wciąż jest ważna – poinformuj nas o obronie.
              </li>
              <li>
               Studia podyplomowe nie dają statusu studenta (wynika z Prawo o szkolnictwie wyższym – słuchacz podyplomowych nie jest studentem w rozumieniu ustawy).
              </li>
            </ul>
          </li>

          <li>
            <strong>Status osoby zatrudnionej – jak aktywować</strong>
            <p>
              <strong>Kto?</strong> Osoby na umowie o pracę albo umowie zlecenia
              z wynagrodzeniem ≥ minimalna płaca.
            </p>
            <p>
              <strong>Co przygotować?</strong>
            </p>
            <ul className="list-disc ml-6">
              <li>
                skan/zdjęcie zaświadczenia o zatrudnieniu (według naszego wzoru
                lub własny dokument pracodawcy), zawierającego:
                <ul className="list-disc ml-6">
                  <li>Twoje dane: imię, nazwisko, adres, PESEL;</li>
                  <li>dane pracodawcy: nazwa, adres, NIP;</li>
                  <li>typ umowy (o pracę / zlecenia), czas trwania;</li>
                  <li>przy umowie zlecenia: wynagrodzenie;</li>
                  <li>pieczątka i podpis pracodawcy;</li>
                  <li>
                    odpowiedzi „tak/nie” na pytania:
                    <ol className="list-decimal ml-6">
                      <li>czy nie jesteś w okresie wypowiedzenia;</li>
                      <li>czy pracodawca nie jest w upadłości/likwidacji;</li>
                      <li>czy wynagrodzenie jest co najmniej minimalne.</li>
                    </ol>
                  </li>
                </ul>
              </li>
            </ul>
            <p>
              <strong>Jak dodać dokument?</strong> Zaloguj się → Dokumenty →
              Zaświadczenia → Dodaj zaświadczenie.
            </p>
            <p>
              <strong>Ważność statusu</strong>
            </p>
            <ul className="list-disc ml-6">
              <li>
                Umowa na czas nieokreślony lub określony (koniec za ≥ 3 mies.) →
                status ważny 3 miesiące.
              </li>
              <li>
                Umowa na czas określony (koniec 3 mies.) → status ważny do końca
                umowy.
              </li>
              <li>
                Przypomnimy 14 dni przed upływem – dodaj nowe zaświadczenie,
                inaczej stracisz możliwość rozliczeń jako zlecenie.
              </li>
            </ul>
            <p>
              <strong>Weryfikacja</strong>
            </p>
            <ul className="list-disc ml-6">
              <li>Po akceptacji – e‑mail + status Aktywny w profilu.</li>
              <li>
                Przy odrzuceniu – e‑mail z powodem i prośbą o uzupełnienie.
              </li>
            </ul>
            <p>
              Wzór zaświadczenia o zatrudnieniu – dostępny do pobrania na końcu
              artykułu (lub poproś support WeExpert o plik).
            </p>
          </li>

          <li>
            <strong>Jaki plik dodać do umowy zlecenia?</strong>
            <ul className="list-disc ml-6">
              <li>
                Student: skan legitymacji (obie strony) lub zaświadczenia z
                uczelni.
              </li>
              <li>
                Osoba zatrudniona: zaświadczenie o zatrudnieniu z elementami
                wskazanymi powyżej.
              </li>
              <li>
                Dodatkowo – jeśli klient tego wymaga – materiały niezbędne do
                wykonania zlecenia (brief, zakres, harmonogram), ale nie są one
                dokumentami statusu.
              </li>
            </ul>
          </li>

          <li>
            <strong>Ile kosztuje rozliczenie umowy zlecenia w WeExpert?</strong>
            <ul className="list-disc ml-6">
              <li>
                Zastosowanie mają opłaty i prowizje określone w cenniku WeExpert
                (widoczne przed akceptacją zlecenia).
              </li>
              <li>
                Całkowity koszt zależy m.in. od wysokości wynagrodzenia i
                wymogów składkowo‑podatkowych (student &lt;26 r.ż. co do zasady
                ma korzystniejsze naliczenia).
              </li>
            </ul>
            <p>
              Przed akceptacją pokażemy podsumowanie kosztów – zobaczysz, ile
              otrzymasz „na rękę”.
            </p>
          </li>

          <li>
            <strong>Minimalna stawka godzinowa</strong>
            <ul className="list-disc ml-6">
              <li>
                Przy umowie zlecenia obowiązuje minimalna stawka godzinowa
                określona przepisami. W formularzu wskaż liczbę godzin lub
                stawki, tak aby zachować zgodność z prawem.
              </li>
              <li>
                System nie pozwoli zatwierdzić zlecenia poniżej obowiązujących
                minimów.
              </li>
            </ul>
          </li>

          <li>
            <strong>Najczęstsze pytania (FAQ)</strong>
            <ul className="list-disc ml-6">
              <li>
                <strong>Czy muszę mieć status, żeby rozliczać zlecenie?</strong>{" "}
                Tak – student albo osoba zatrudniona (jeden z nich). Bez
                aktywnego statusu prace kwalifikujące się jako zlecenie nie będą
                dostępne do rozliczenia na tej podstawie.
              </li>
              <li>
                <strong>Kiedy umowa staje się zawarta?</strong> Z chwilą
                opłacenia przez klienta faktury pro forma wysłanej przez
                WeExpert.
              </li>
              <li>
                <strong>Co się stanie, jeśli status wygaśnie?</strong> Do czasu
                ponownej aktywacji statusu nie rozliczysz nowych prac jako
                zlecenie (nadal możesz rozliczać prace kwalifikujące się jako
                dzieło).
              </li>
              <li>
                <strong>Czy studia podyplomowe nadają status studenta?</strong>{" "}
                Nie. Słuchacz studiów podyplomowych nie jest studentem w
                rozumieniu ustawy – umowy zlecenia będą podlegały odpowiednim
                składkom niezależnie od wieku.
              </li>
            </ul>
          </li>

          <li>
            <strong>Podsumowanie – decyzja w 30 sekund</strong>
            <ul className="list-disc ml-6">
              <li>Masz efekt do oddania? → najczęściej dzieło.</li>
              <li>Rozliczasz czas/usługę ciągłą? → najczęściej zlecenie.</li>
              <li>
                Spełniasz warunki studenta &lt;26? → aktywuj status studenta.
              </li>
              <li>
                Pracujesz etat/zlecenie ≥ minimalna? → aktywuj status osoby
                zatrudnionej.
              </li>
            </ul>
          </li>

          <li>
            <strong>Załączniki / Pliki do pobrania</strong>
            <ul className="list-disc ml-6">
              <li>
                Wzór zaświadczenia o zatrudnieniu (PDF/DOCX) – skontaktuj się z
                pomocą WeExpert, aby otrzymać aktualny plik.
              </li>
            </ul>
          </li>
        </ol>
      </div>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dodatki – wersja rozszerzona (WeExpert)
      </h3>

      <ol className="list-decimal ml-6">
        <li>
          <strong>Jaki plik dodać do umowy zlecenia?</strong>
          <p>
            Każde rozliczenie w WeExpert wymaga pliku potwierdzającego wykonanie
            pracy. Dla umowy zlecenia podstawą jest formularz godzinowy
            (timesheet):
          </p>
          <ul className="list-disc ml-6">
            <li>
              pobierz i uzupełnij nasz wzór (udostępniamy na żądanie) lub użyj
              własnego,
            </li>
            <li>
              wskaż okres, liczbę godzin, stawki oraz krótki opis czynności.
            </li>
          </ul>
          <p>Dodatkowo, jeśli to możliwe, dołącz:</p>
          <ul className="list-disc ml-6">
            <li>
              zrzuty ekranu / krótki raport zadań (np. tematy zajęć przy
              szkoleniach; liczba obsłużonych wątków/połączeń w pracach
              biurowych; liczba interwencji przy administracji serwisów).
            </li>
          </ul>
          <p>
            W samym formularzu rozliczenia w WeExpert opisz pracę w kroku Opis lub Opis projektu .<br></br>
           Student: przy wyborze kategorii wskaż „Zlecenia dla studentów” – inaczej rozliczenie zostanie potraktowane jak umowa o dzieło (z pobraniem podatku wg zasad dla dzieła)
          </p>
        </li>

        <li>
          <strong>Ile kosztuje rozliczenie umowy zlecenia w WeExpert?</strong>
          <ul className="list-disc ml-6">
            <li>
              Opłata serwisowa – zgodnie z aktualnym cennikiem WeExpert (taka
              sama dla dzieła i zlecenia). Całkowity koszt widzisz przed
              akceptacją.
            </li>
            <li>
              Podatek dochodowy – stawka 12%. Dla kwot ≥ 200 zł można zastosować
              20% KUP (koszty uzyskania przychodu).
            </li>
            <li>
              Ulga dla młodych (PIT 0): do 26 r.ż. – brak PIT od przychodów
              m.in. z umów zlecenia do limitu 85 528 zł w roku.
            </li>
            <li>
              Składka zdrowotna – dla osób ze statusem zatrudnionego naliczamy
              9% od kwoty brutto (po odjęciu opłaty serwisowej).
            </li>
            <li>
              Studenci (do 26 r.ż.) – bez składki zdrowotnej przez WeExpert;
              zwykle są zgłoszeni do ubezpieczenia przez rodzinę/uczelnę.
            </li>
          </ul>
          <p>
            Potrzebujesz symulacji „na rękę”? – napisz do nas, zrobimy
            wyliczenie przed zawarciem umowy.
          </p>
        </li>

        <li>
          <strong>Minimalna stawka godzinowa (umowa zlecenia)</strong>
          <p>
            W zleceniu rozliczasz czas. Obowiązuje minimalna stawka godzinowa
            określona przepisami – od 1 stycznia 2025 r.: 30,50 zł brutto/h.
            System nie pozwoli zatwierdzić zlecenia poniżej minimum.
          </p>
        </li>

        <li>
          <strong>WeExpert dla freelancerów – co zyskujesz?</strong>
          <ul className="list-disc ml-6">
            <li>
              Faktura VAT bez firmy – rozliczaj z klientami jako freelancer bez
              zakładania działalności, z szybką wypłatą.
            </li>
            <li>
              Podpisanie umowy online – zabezpieczenie płatności przed startem
              pracy i bezpieczny transfer plików.
            </li>
            <li>WeExpert Jobs – giełda zleceń, codziennie nowe ogłoszenia.</li>
          </ul>
          <p>
            <strong>„Jednorazowa Umowa” – gdy praca już wykonana</strong>
          </p>
          <ol className="list-decimal ml-6">
            <li>
              Wypełnij formularz i wgraj pliki potwierdzające wykonanie pracy.
            </li>
            <li>Wyślemy klientowi proformę.</li>
            <li>
              Po opłaceniu – wystawiamy fakturę VAT klientowi, a Tobie wypłacamy
              wynagrodzenie netto (zwykle do 24h w dni robocze od
              akceptacji/płatności).
            </li>
          </ol>
          <p>
            <strong>WeExpert Jobs – jak aplikować?</strong>
          </p>
          <ul className="list-disc ml-6">
            <li>Uzupełnij profil i dodaj portfolio/CV.</li>
            <li>
              Po wyborze Twojej oferty – dalszy proces jak w „Podpisz umowę”.
            </li>
          </ul>
        </li>

        <li>
          <strong>Prawa autorskie i licencje</strong>
          <ul className="list-disc ml-6">
            <li>
              Przeniesienie praw autorskich – przekazujesz klientowi majątkowe
              prawa autorskie na zawsze; nie możesz potem dalej monetyzować
              utworu.
            </li>
            <li>
              Licencja – zachowujesz prawa, klient dostaje pozwolenie na
              korzystanie (w WeExpert standardowo: 15 lat).
            </li>
          </ul>
        </li>
      </ol>

      <h3 className="text-xl font-semibold mt-10 mb-4">
        Dodatki – wersja rozszerzona (WeExpert)
      </h3>

      <p className="font-semibold mt-6">
        A) Jaki plik dodać do umowy zlecenia?
      </p>
      <p>
        Każde rozliczenie w WeExpert wymaga pliku potwierdzającego wykonanie
        pracy.
      </p>
      <p>Dla umowy zlecenia podstawą jest formularz godzinowy (timesheet):</p>
      <ul className="list-disc ml-6 mt-2">
        <li>
          pobierz i uzupełnij nasz wzór (udostępniamy na żądanie) lub użyj
          własnego,
        </li>
        <li>wskaż okres, liczbę godzin, stawki oraz krótki opis czynności.</li>
      </ul>
      <p>Dodatkowo, jeśli to możliwe, dołącz:</p>
      <ul className="list-disc ml-6 mt-2">
        <li>
          zrzuty ekranu / krótki raport zadań (np. tematy zajęć przy
          szkoleniach; liczba obsłużonych wątków/połączeń w pracach biurowych;
          liczba interwencji przy administracji serwisów).
        </li>
      </ul>
      <p>
        W samym formularzu rozliczenia w WeExpert opisz pracę w kroku Opis lub
        Opis projektu.
        <br />
        Student: przy wyborze kategorii wskaż „Zlecenia dla studentów” – inaczej
        rozliczenie zostanie potraktowane jak umowa o dzieło (z pobraniem
        podatku wg zasad dla dzieła).
      </p>

      <p className="font-semibold mt-6">
        B) Ile kosztuje rozliczenie umowy zlecenia w WeExpert?
      </p>
      <p>
        Opłata serwisowa – zgodnie z aktualnym cennikiem WeExpert (taka sama dla
        dzieła i zlecenia). Całkowity koszt widzisz przed akceptacją.
      </p>
      <p>
        Podatek dochodowy – stawka 12%. Dla kwot ≥ 200 zł można zastosować 20%
        KUP (koszty uzyskania przychodu).
      </p>
      <ul className="list-disc ml-6 mt-2">
        <li>
          Ulga dla młodych (PIT 0): do 26 r.ż. – brak PIT od przychodów m.in. z
          umów zlecenia do limitu 85 528 zł w roku.
        </li>
      </ul>
      <p>
        Składka zdrowotna – dla osób ze statusem zatrudnionego naliczamy 9% od
        kwoty brutto (po odjęciu opłaty serwisowej).
      </p>
      <ul className="list-disc ml-6 mt-2">
        <li>
          Studenci (do 26 r.ż.) – bez składki zdrowotnej przez WeExpert; zwykle
          są zgłoszeni do ubezpieczenia przez rodzinę/uczelnę.
        </li>
      </ul>
      <p>
        Potrzebujesz symulacji „na rękę”? – napisz do nas, zrobimy wyliczenie
        przed zawarciem umowy.
      </p>

      <p className="font-semibold mt-6">
        C) Minimalna stawka godzinowa (umowa zlecenia)
      </p>
      <p>
        W zleceniu rozliczasz czas. Obowiązuje minimalna stawka godzinowa
        określona przepisami – od 1 stycznia 2025 r.: 30,50 zł brutto/h. System
        nie pozwoli zatwierdzić zlecenia poniżej minimum.
      </p>

      <p className="font-semibold mt-6">
        D) WeExpert dla freelancerów – co zyskujesz?
      </p>
      <ul className="list-disc ml-6 mt-2">
        <li>
          Faktura VAT bez firmy – rozliczaj z klientami jako freelancer bez
          zakładania działalności, z szybką wypłatą.
        </li>
        <li>
          Podpisanie umowy online – zabezpieczenie płatności przed startem pracy
          i bezpieczny transfer plików.
        </li>
        <li>WeExpert Jobs – giełda zleceń, codziennie nowe ogłoszenia.</li>
      </ul>

      <p className="mt-4 font-semibold">
        „Jednorazowa Umowa” – gdy praca już wykonana
      </p>
      <ol className="list-decimal ml-6 mt-2">
        <li>
          Wypełnij formularz i wgraj pliki potwierdzające wykonanie pracy.
        </li>
        <li>Wyślemy klientowi proformę.</li>
        <li>
          Po opłaceniu – wystawiamy fakturę VAT klientowi, a Tobie wypłacamy
          wynagrodzenie netto (zwykle do 24h w dni robocze od
          akceptacji/płatności).
        </li>
      </ol>

      <p className="font-semibold mt-6">WeExpert Jobs – jak aplikować?</p>
      <ul className="list-disc ml-6 mt-2">
        <li>Uzupełnij Profili dodaj portfolio/CV.</li>
        <li>Po wyborze Twojej oferty – dalszy proces jak w „Podpisz umowę”.</li>
      </ul>

      <p className="font-semibold mt-6">E) Prawa autorskie i licencje</p>
      <ul className="list-disc ml-6 mt-2">
        <li>
          Przeniesienie praw autorskich – przekazujesz klientowi majątkowe prawa
          autorskie na zawsze; nie możesz potem dalej monetyzować utworu.
        </li>
        <li>
          Licencja – zachowujesz prawa, klient dostaje pozwolenie na korzystanie
          (w WeExpert standardowo: 15 lat).
        </li>
      </ul>

      <div className="overflow-x-auto mt-6">
        <table className="min-w-full border border-gray-300">
          <thead className="bg-gray-100">
            <tr>
              <th className="border border-gray-300 px-4 py-2 text-left"> </th>
              <th className="border border-gray-300 px-4 py-2 text-left">
                Licencja
              </th>
              <th className="border border-gray-300 px-4 py-2 text-left">
                Przeniesienie praw
              </th>
            </tr>
          </thead>
          <tbody>
            <tr className="bg-white">
              <td className="border border-gray-300 px-4 py-2">
                Czy zachowujesz możliwość dalszej sprzedaży/wykorzystania?
              </td>
              <td className="border border-gray-300 px-4 py-2">Tak</td>
              <td className="border border-gray-300 px-4 py-2">
                Nie (przechodzi na klienta)
              </td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border border-gray-300 px-4 py-2">Czas</td>
              <td className="border border-gray-300 px-4 py-2">
                Określony (np. 15 lat)
              </td>
              <td className="border border-gray-300 px-4 py-2">Bezterminowo</td>
            </tr>
            <tr className="bg-white">
              <td className="border border-gray-300 px-4 py-2">
                Wymogi formalne
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Bez dodatkowych dokumentów
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Protokół przeniesienia (podpis elektroniczny)
              </td>
            </tr>
            <tr className="bg-gray-50">
              <td className="border border-gray-300 px-4 py-2">
                Kiedy dokument jest dostępny
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Od razu po rozliczeniu
              </td>
              <td className="border border-gray-300 px-4 py-2">
                Do 7 dni roboczych po rozliczeniu
              </td>
            </tr>
          </tbody>
        </table>

        <div className="space-y-6">
          <p>
            W formularzu rozliczenia wybierasz jedną z opcji: przeniesienie,
            Brak przeniesienia praw autorskich, Licencja.
          </p>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            F) Podwyższone koszty uzyskania przychodu (KUP 50%)
          </h3>
          <ul className="list-disc list-inside space-y-2">
            <li>
              Standardowo KUP = 20% (przy niektórych pracach 0% – np. dzieło
              &lt; 200 zł bez przeniesienia praw).
            </li>
            <li>
              Dla prac twórczych (np. programy komputerowe, grafika, muzyka,
              teksty, architektura itd.) przy przeniesieniu praw lub licencji
              można zastosować KUP 50% – jeśli dana kategoria prac mieści się w
              przepisach.
            </li>
          </ul>

          <p className="mt-4 font-semibold">Przykłady:</p>
          <ul className="list-decimal list-inside space-y-2 ml-4">
            <li>
              Aplikacja mobilna → można przenieść prawa/licencję TAK; KUP 50%
              TAK → niższy podatek.
            </li>
            <li>
              Zarządzanie kampaniami Ads → przeniesienie/licencja TAK/NIE w
              praktyce nie obniża podatku (brak KUP 50%).
            </li>
            <li>
              Tłumaczenie symultaniczne → przeniesienie/licencja NIE; KUP 50%
              NIE.
            </li>
          </ul>

          <p className="mt-4">
            Jeśli wybierzesz przeniesienie/licencję tam, gdzie to niedozwolone,
            skorygujemy rozliczenie (to może podnieść podatek i obniżyć
            wypłatę). O zmianach zawsze informujemy.
          </p>
          <p>
            Limit: KUP 50% można stosować do przychodów do 240 000 zł rocznie
            (co odpowiada 120 000 zł kosztów). Po przekroczeniu limitu –
            stosujemy KUP 20%.
          </p>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            G) Gdzie znaleźć dokumenty po rozliczeniu?
          </h3>
          <p>
            Zaloguj się → Dokumenty (tam pobierzesz protokół/licencję oraz
            faktury).
          </p>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            Cennik dla freelancerów – WeExpert
          </h3>
          <p>Ostatnia aktualizacja: 9 września 2025 r.</p>
          <p>
            Administrator serwisu / wystawca umów: WEEXPERT SP. Z O.O., ul.
            Marsz. Józefa Piłsudskiego 74/320, 50‑020 Wrocław, KRS: 0000986528,
            NIP: 9671458021, REGON: 52278693000000, kapitał zakładowy: 106 700
            zł.
          </p>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            1) Stawki i limity – w skrócie
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Opłata serwisowa: 5% od wartości netto umowy (PLN).</li>
            <li>Min./maks. opłata od umowy (PLN): min. 65 zł, max 499 zł. do 10 000 netto  $, powyższej  dodatkowo 3 %</li>
            <li>
              Miesięczny limit opłat (PLN): 499 zł – po jego osiągnięciu każde
              kolejne rozliczenie w miesiącu jest bez opłaty serwisowej.
            </li>
            <li>
              Waluty EUR/USD/GBP: opłata 5%, min. 18, max 135 (EUR/USD/GBP).
            </li>
            <li>Rejestracja i posiadanie konta: zawsze darmowe.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            2) Jak działa poziom darmowych rozliczeń (miesięczny limit)?
          </h3>
          <p>
            Sumujemy wszystkie opłaty serwisowe z danego miesiąca na Twoim
            koncie. Po osiągnięciu limitu (499 zł lub w Standard: 499 zł; w
            walutach: 135)
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
               Wszystkie następne umowy w tym miesiącu rozliczasz bez opłaty serwisowej (pobieramy tylko należne podatki/składki zgodnie z prawem).
            </li>
            <li>
             Jeżeli w bieżącym miesiącu rozliczyłeś (aś) łącznej kwotę netto powyżej 10 000 $ obowiązuje dodatkowa prowizja 3% od kwoty netto wszystkich rozliczeń po 10 000 $ netto
            </li>
          </ul>
          <p className="mt-2">
            Uwaga: system czasem pokazuje opłatę w formularzu przed
            zaksięgowaniem wpłaty od klienta. Ostatecznie liczy się data
            zaksięgowania płatności, wtedy weryfikujemy limit i ewentualnie
            „zerujemy” opłatę.
          </p>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            3) Kiedy umowa liczy się do limitu?
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              Data rozliczenia = dzień zaksięgowania wpłaty klienta za proformę.
              <ul className="list-disc list-inside ml-4">
                <li>
                  Przykład: faktura wystawiona 31.01, klient płaci 03.02 → umowa
                  liczy się do limitu lutego.
                </li>
              </ul>
            </li>
            <li>
              Jeśli w styczniu miałeś limit „wyklikaliście” do zera, ale klient
              opłaci dopiero w lutym – ta umowa trafi do lutego i rozliczy się
              wg stawek/limitów lutowych.
            </li>
            <li>
              Wielowalutowość: rozliczenia w różnych walutach przeliczamy i
              sumujemy proporcjonalnie do odpowiednich limitów.
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            4) Co wlicza się do limitu, a co nie?
          </h3>
          <p>Wlicza się:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              opłaty serwisowe z Twoich umów rozliczanych przez WeExpert Jobs
              (liczone od kwoty netto na fakturze klienta).
            </li>
          </ul>
          <p>Nie wlicza się:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>zaliczki na PIT;</li>
            <li>
              opłat dodatkowych (np. opłata operacyjna dostawcy płatności,
              opłata kartowa);
            </li>
            <li>usług dodatkowych (np. wysyłka dokumentów pocztą);</li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            5) Jak liczymy opłatę serwisową dla pojedynczej umowy?
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              Podstawa naliczenia to kwota netto na fakturze (nie „na rękę”).
            </li>
            <li>Stawka: 5% (PLN) (EUR/USD/GBP).</li>
            <li>
              Zasada min./max. na pojedynczą umowę:
              <ul className="list-disc list-inside ml-4">
                <li>PLN: min. 65 zł, max 499 zł;</li>
                <li>EUR/USD/GBP: min. 18, max 135 .</li>
              </ul>
            </li>
            <li>
              Miesięczny limit opłat (PLN 499; waluty 135) działa niezależnie od
              min./max per umowa.
            </li>
            <li>
              Dodatkowa prowizja 3% naliczona tylko dla kwot powyżej 10 000 $
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            6) Inne opłaty (freelancer)
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Przelew ekspresowy wynagrodzenia: 20 zł lub 10 EUR/USD/GBP.</li>
            <li>Wysyłka dokumentów pocztą: 50 zł lub 10 EUR/USD/GBP.</li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            7) Dodatkowe opłaty (dla zleceniodawców)
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Wysyłka dokumentów pocztą: 50 zł lub 20 EUR/USD/GBP.</li>
            <li>
              Opłata operacyjna przy szybkich płatnościach – zależy od kraju i
              waluty umowy (pokrywa koszty infrastruktury i rozliczeń).
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            8) Przykłady kalkulacji (PLN)
          </h3>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              Umowa netto 1 500 zł
              Opłata 5% = 75 zł (min. 65 zł nie ma zastosowania, max 499 zł nie ma zastosowania).
            </li>
            <li>Umowa netto 500 zł
              Opłata 5% = 25 zł (≤ 65 zł, == 65 zł)</li>
            <li>Umowa netto 11 000 zł
              Opłata 5% = 550 zł (≥ 499 zł, == 499 zł).</li>
            <li>
              Kolejne umowy po osiągnięciu 499 zł w miesiącu
              0 zł opłaty serwisowej do końca miesiąca albo osiągnięcia 10 000 $ (pobieramy tylko należne podatki/skład
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            9) Jakie prace można rozliczyć przez WeExpert?
          </h3>
          <p>
            W WeExpert możesz wystawić klientowi fakturę i otrzymać płatność za
            większość prac zdalnych, a także niektóre usługi biurowe i inne.
          </p>

          <h4 className="text-lg font-semibold mt-6 mb-2">
            a) Umowa o dzieło – podstawa rozliczenia
          </h4>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              Każde rozliczenie „Jednorazowa Umowa” oznacza powstanie umowy o
              dzieło między Tobą a WeExpert.
            </li>
            <li>Klient płaci WeExpert, a my przekazujemy Ci wynagrodzenie.</li>
            <li>
              Umowa o dzieło wymaga konkretnego rezultatu – np. grafika, tekst,
              kod.
            </li>
          </ul>
          <p className="mt-2 font-semibold">
            Przykładowe prace rozliczane na umowę o dzieło:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-6">
            <li>serwisy internetowe (strony, sklepy online),</li>
            <li>multimedia (wideo, animacje, muzyka, fotografia),</li>
            <li>
              programowanie i IT (oprogramowanie, aplikacje, administracja
              serwerami),
            </li>
            <li>
              marketing (kampanie, social media, copywriting, SEO, analityka,
              telemarketing),
            </li>
            <li>design (grafika 2D/3D, architektura, UX/UI),</li>
            <li>tłumaczenia,</li>
          </ul>

          <h4 className="text-lg font-semibold mt-6 mb-2">b) Umowa zlecenia</h4>
          <p>
            Jeśli masz status studenta (do 26 lat) lub status osoby zatrudnionej
            (umowa o pracę/zlecenie ≥ płaca minimalna), możesz rozliczać również
            umowy zlecenia.
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>Przedmiotem jest czynność, a nie rezultat.</li>
            <li>
              Przykłady: nauka języków, obsługa klienta, sprzedaż, doradztwo,
              konsultacje, prezentacje.
            </li>
            <li>
              Często rozlicza się to dwoma częściami: przygotowanie (dzieło) +
              wykonanie czynności (zlecenie).
            </li>
          </ul>

          <h3 className="text-xl font-semibold mt-10 mb-4">
            10) WeExpert dla zleceniodawców
          </h3>
          <p>
            WeExpert to rozwiązanie dla firm i osób prywatnych, które zlecają
            pracę freelancerom.
          </p>
          <p className="mt-2 font-semibold">Korzyści dla zleceniodawcy:</p>
          <ul className="list-disc list-inside space-y-2 ml-4">
            <li>
              Faktura VAT zamiast umów cywilnoprawnych – rozliczamy wykonawcę w
              modelu B2B.
            </li>
            <li>
              Umowy online – zabezpieczenie płatności przed startem pracy.
            </li>
            <li>
              Mniej formalności księgowych – wszystkie obowiązki (ZUS, PIT,
              formalności) bierze na siebie WeExpert.
            </li>
            <li>
              Bezpieczeństwo płatności – freelancer dostaje wynagrodzenie
              dopiero po Twojej akceptacji.
            </li>
          </ul>
          <p className="mt-2 font-semibold">Jak to działa:</p>
          <ol className="list-decimal list-inside space-y-2 ml-4">
            <li>Freelancer wypełnia formularz „Jednorazowa Umowa”.</li>
            <li>Dodaje pliki potwierdzające wykonanie pracy.</li>
            <li>
              My wysyłamy Ci proformę → po opłaceniu wystawiamy fakturę VAT.
            </li>
            <li>
              Freelancer otrzymuje wynagrodzenie (zwykle w 24h od
              akceptacji/zaksięgowania).
            </li>
          </ol>
          <p className="mt-2">
            Jeśli nie masz jeszcze wykonawcy: Skorzystaj z WeExpert Jobs –
            giełdy zleceń. Publikujesz ogłoszenie, otrzymujesz oferty od
            freelancerów i wybierasz odpowiednią osobę. Resztą (umowa,
            płatności, podatki) zajmuje się WeExpert.
          </p>
          <p className="mt-2">
            Dzięki temu zarówno freelancer, jak i zleceniodawca mają pewność
            legalnego i bezpiecznego rozliczenia – bez zbędnej biurokracji.
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <h3 className="text-xl font-semibold mt-10 mb-4">
          Cennik dla zleceniodawców – WeExpert
        </h3>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Jak skorzystać z cennika dla zleceniodawców?
        </h4>
        <p>
          Domyślnie opłatę serwisową pokrywa freelancer. Jeśli chcesz, aby
          opłatę serwisową pokrywał zleceniodawca (Ty), daj nam znać przez
          kontakt w serwisie{" "}
          <a href="mailto:info@weexpert.io" className="underline text-blue-500">
            info@weexpert.io
          </a>{" "}
          – ustawimy rozliczenia tak, by opłata była po Twojej stronie i
          doliczana do faktur.
        </p>
        <p>
          Opłata serwisowa jest doliczana do faktur dotyczących transakcji z
          wykonawcami rozliczanych w WeExpert. Rejestracja i posiadanie konta
          pozostają bezpłatne.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Nowy cennik w pigułce
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Im więcej wykonawców – tym niższe stawki: działają pakiety
            uzależnione od średniej miesięcznej liczby freelancerów, których
            rozliczasz.
          </li>
          <li>Maksymalna opłata serwisowa per rozliczenie: 499 zł.</li>
          <li>Minimalna opłata serwisowa per rozliczenie: 65 zł.</li>
          <li>
            Brak abonamentu i opłat na start: płacisz tylko, gdy faktycznie
            rozliczasz pracę.
          </li>
        </ul>

        <p className="mt-4 font-semibold">Stałe korzyści w każdym pakiecie:</p>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>zbiorcze płatności, zbiorcze faktury;</li>
          <li>escrow (zabezpieczenie płatności);</li>
          <li>wsparcie Customer Service;</li>
          <li>dostęp do bazy freelancerów;</li>
          <li>automatyczne nabywanie praw autorskich online (gdy dotyczy).</li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Pakiety dla zleceniodawców (stawki przykładowe)
        </h4>
        <p>
         Stawki procentowe liczymy od kwoty netto zlecenia. Zawsze obowiązuje min 65 zł / max 499 zł za pojedynczą transakcję.
          <a href="mailto:info@weexpert.io" className="underline text-blue-500">
            skontaktuj się z działem sprzedaży
          </a>
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Pro forma – co to jest i dlaczego ją dostajesz?
        </h4>
        <p>
          <span className="font-semibold">Czym jest pro forma?</span> Faktura
          pro forma to oferta handlowa potwierdzająca wartość i zakres
          zamówionych usług; pozwala sprawdzić dane przed wystawieniem faktury
          VAT.
        </p>
      </div>

      <div className="space-y-6">
        <h3 className="text-xl font-semibold mt-10 mb-4">
          Czym różni się od faktury VAT?
        </h3>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Pro forma musi być oznaczona jako „pro forma”.</li>
          <li>
            Nie jest dokumentem księgowym – nie wywołuje skutków podatkowych,
            nie trafia do ewidencji.
          </li>
        </ul>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Kiedy ją wystawiamy?
        </h3>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Zawsze przed fakturą VAT – aby zweryfikować dane i uniknąć korekt.
          </li>
          <li>
            Bywa traktowana jako potwierdzenie woli zawarcia transakcji
            (oferta).
          </li>
        </ul>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Pro forma w WeExpert – przebieg
        </h3>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>Wykonawca inicjuje rozliczenie (formularz).</li>
          <li>
            Wysyłamy Ci pro formę mailowo i publikujemy w sekcji Umowy na Twoim
            koncie.
          </li>
          <li>
            Możesz poprosić o zmianę dowolnych danych pro formy (to łatwiejsze
            niż korekty VAT).
          </li>
          <li>
            Po opłaceniu proformy wystawiamy fakturę VAT i uruchamiamy dalszy
            proces (escrow/akceptacja plików → wypłata wykonawcy).
          </li>
        </ol>

        <p className="mt-4">
          Dane na proformie: tytuł i status dokumentu, numer (np. „UM…”), dane
          wystawcy i odbiorcy, przedmiot transakcji, kwoty brutto/netto i stawka
          VAT, termin płatności. NIP klienta dodajemy na fakturze VAT – pro
          forma go zwykle nie zawiera, aby uniknąć nieporozumień księgowych.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Nie doszła faktura VAT?
        </h3>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Sprawdź spam / filtry pocztowe.</li>
          <li>
            Pobierz dokumenty z konta: Umowy Jednorazowy → [Twoja umowa] →
            Dokumenty (pro forma, faktura VAT, pliki z pracą, protokół
            przeniesienia praw, potwierdzenie zawarcia umowy).
          </li>
          <li>
            Możesz też poprosić wykonawcę o ponowne przesłanie z jego profilu.
          </li>
        </ul>

        <p className="mt-4">
          Masz pytania o pakiet, zmianę pakietu albo sposób naliczania opłaty?
          Skontaktuj się z nami przez panel WeExpert – podpowiemy, co będzie
          najkorzystniejsze.
        </p>

        <h3 className="text-xl font-semibold mt-10 mb-4">
          Polityka Prywatności – skrót
        </h3>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          I. Postanowienia ogólne
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            WeExpert jest administratorem danych osobowych użytkowników (RODO –
            rozporządzenie (UE) 2016/679 oraz właściwe przepisy krajowe).
          </li>
          <li>
            Kontakt w sprawach ochrony danych: przez formularz kontaktowy/adres
            e‑mail wskazany w serwisie{" "}
            <a
              href="mailto:info@weexpert.io"
              className="underline text-blue-500"
            >
              info@weexpert.io
            </a>
            .
          </li>
        </ul>
        <p className="mt-2">
          Co to oznacza? WeExpert określa cele i sposoby przetwarzania danych i
          odpowiada za zgodność z prawem. Dane osobowe to informacje
          identyfikujące osobę (np. imię i nazwisko, e‑mail, adres, IP).
          Przetwarzanie obejmuje m.in. zbieranie, przechowywanie,
          wykorzystywanie i usuwanie. Cel tej polityki: informujemy, jakie dane
          zbieramy przez serwis WeExpert, do jakich celów i na jakich podstawach
          je przetwarzamy, jak długo je przechowujemy, komu je udostępniamy i
          jakie prawa Ci przysługują. Korzystanie z serwisu oznacza akceptację
          niniejszej polityki. Pojęcia pisane wielką literą mają znaczenie
          zdefiniowane w Regulaminie WeExpert.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          II. Kategorie danych
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Konto i profil – dane identyfikacyjne i rozliczeniowe (np. imię,
            nazwisko, e‑mail, telefon, adres, NIP – jeśli dotyczy, numer
            rachunku), informacje widoczne w profilu (dobrowolne).
          </li>
          <li>
            Transakcje i komunikacja – informacje o zleceniach, płatnościach,
            wiadomościach, komentarzach.
          </li>
          <li>
            Obsługa użytkownika – dane podawane w zapytaniach/reklamacjach (np.
            e‑mail, dane podatkowe, jeśli wymagane).
          </li>
          <li>
            Dane z urządzeń/WWW – adres IP, identyfikatory urządzeń/aplikacji,
            logi, cookies i podobne technologie (zgodnie z Polityką cookies).
          </li>
          <li>
            Logowanie zewnętrzne (np. Google) – jeśli wybierzesz tę opcję: imię
            i nazwisko, e‑mail, ID konta, zdjęcie; połączenie możesz odłączyć.
          </li>
          <li>
            Ankiety/badania – dobrowolne dane i opinie (statystyka, dostosowanie
            usług).
          </li>
          <li>
            Weryfikacja tożsamości (KYC/AML) – tylko, gdy wymaga tego
            prawo/bezpieczeństwo (np. imię, nazwisko, data urodzenia,
            PESEL/dokument – także u naszych dostawców KYC na podstawie umowy
            powierzenia).
          </li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          III. Cele i podstawy prawne
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Umowa/świadczenie usług (art. 6 ust.1 lit. b RODO) – założenie i
            prowadzenie konta, rozliczenia, płatności, komunikacja,
            bezpieczeństwo usług.
          </li>
          <li>
            Obowiązek prawny (art. 6 ust.1 lit. c) – rozliczenia
            podatkowe/rachunkowe, przeciwdziałanie nadużyciom, AML/KYC,
            zgłoszenia sygnalistów, rozliczalność RODO.
          </li>
          <li>
            Uzasadniony interes (art. 6 ust.1 lit. f) – analityka i rozwój
            serwisu, bezpieczeństwo IT, korespondencja i archiwizacja, marketing
            własny (w tym ograniczone profilowanie), weryfikacja botów (np.
            reCAPTCHA).
          </li>
          <li>
            Zgoda (art. 6 ust.1 lit. a) – tylko tam, gdzie wymagana (np.
            niektóre cookies, ankiety, przekazywanie danych partnerom dla
            personalizacji). Zgoda jest dobrowolna i może być cofnięta w każdej
            chwili.
          </li>
        </ul>
        <p className="mt-2">
          Brak zautomatyzowanego podejmowania decyzji wywołujących skutki prawne
          bez udziału człowieka.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          IV. Udostępnianie danych
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Podmioty przetwarzające (hosting/chmura, płatności, KYC, obsługa
            klienta, księgowość, marketing, prawnicy itp.) – działają na
            podstawie umów powierzenia i naszych instrukcji.
          </li>
          <li>
            Poza EOG – wyłącznie przy zastosowaniu mechanizmów transferowych
            zgodnych z prawem (np. standardowe klauzule umowne).
          </li>
          <li>
            Organy publiczne – wyłącznie, gdy wymagają tego przepisy (np. sądy,
            organy ścigania, skarbowe).
          </li>
          <li>Strony umów – w zakresie niezbędnym do realizacji zlecenia.</li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          V. Okres przechowywania
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            tak długo, jak masz aktywne konto i/lub przez okres wymagany
            przepisami (np. dokumenty księgowe – co do zasady 5 lat), a dla zgód
            – do ich wycofania, z uwzględnieniem obowiązków rozliczalności.
          </li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">VI. Twoje prawa</h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            dostęp, kopia danych; sprostowanie; usunięcie; ograniczenie;
            sprzeciw (w tym wobec marketingu bezpośredniego); przenoszenie;
            wycofanie zgody; skarga do PUODO.
          </li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">VII. Kontakt</h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Skorzystaj z danych kontaktowych wskazanych w serwisie{" "}
            <a
              href="mailto:info@weexpert.io"
              className="underline text-blue-500"
            >
              info@weexpert.io
            </a>{" "}
            (formularz/e‑mail). Odpowiadamy bez zbędnej zwłoki, najpóźniej w
            ciągu miesiąca.
          </li>
        </ul>

        <p className="mt-4">
          Serwis może być chroniony mechanizmami bezpieczeństwa (np. reCAPTCHA).
          Warunki i politykę prywatności odpowiedniego dostawcy publikujemy w
          polityce cookies.
        </p>
      </div>

      <div className="space-y-6">
        <h3 className="text-xl font-semibold mt-10 mb-4">
          Regulamin – wersja skrócona (WeExpert)
        </h3>
        <p>
          Uwaga: to tylko pomocne streszczenie. Prawnie wiążąca jest pełna
          wersja Regulaminu w języku polskim (z tłumaczeniem na język
          angielski). Link do pełnego tekstu udostępniamy w serwisie.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 1 – Definicje
        </h4>
        <p>
          Pojęcia używane w serwisie i Regulaminie (m.in. ogłoszenie, zlecenie,
          umowa, dzieło, freelancer, zleceniodawca, konto).
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 2 – Postanowienia ogólne
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            WeExpert to platforma pośrednicząca – nie świadczy prac za
            freelancerów.
          </li>
          <li>
            Freelancer ponosi pełną odpowiedzialność za swoje dzieło/usługę.
          </li>
          <li>
            Spory co do umów rozwiązywane są między stronami; WeExpert może
            wspierać kontakt i mediację.
          </li>
          <li>
            Zakaz wyprowadzania rozliczeń poza serwis (grozi blokadą konta i
            działaniami odszkodowawczymi).
          </li>
          <li>Zakaz spamu/nachalnych reklam (blokada konta).</li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 3 – Rejestracja
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>Założenie konta = akceptacja Regulaminu.</li>
          <li>
            Odpowiadasz za prawdziwość danych; możemy żądać potwierdzenia.
          </li>
          <li>Jedno konto freelancera na osobę.</li>
          <li>
            Rezygnacja/usunięcie danych – przez kontakt wskazany w serwisie.
          </li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 4 – Licencje i prawa autorskie
        </h4>
        <p>
          Freelancer może przenieść prawa majątkowe lub udzielić licencji
          niewyłącznej na korzystanie z utworu (zakres, pola eksploatacji i
          warunki są wskazywane w formularzu/umowie).
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">Artykuł 5 – Opłaty</h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Większość funkcji serwisu jest bezpłatna; opłata serwisowa wg
            Cennika doliczana do zleceń.
          </li>
          <li>
            Dodatkowo płatne (jeśli zamówione): pominięcie proformy/wydłużenie
            terminu, wysyłka papierowych dokumentów, szybkie płatności itp. –
            zgodnie z załącznikiem do Regulaminu (Cennik).
          </li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 6 – Inne postanowienia
        </h4>
        <p>
          Możemy zablokować/usunąć konto, ogłoszenia i oferty przy naruszeniach
          prawa/Regulaminu/dobrych obyczajów; konsekwencją jest skasowanie
          aktywności powiązanych z kontem.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 7 – Umowy sporne
        </h4>
        <p>
          Nie odpowiadamy za działania użytkowników; w ramach wsparcia
          przedstawiamy rekomendacje rozwiązania sporu zgodnie z Regulaminem i
          dokumentacją umowy.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuły 8-9 – Reklamacje i ADR
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Reklamacje zgłaszaj przez formularz/e‑mail podany w serwisie (podaj
            dane konta, numer umowy/ogłoszenia i materiał do reklamacji).
          </li>
          <li>
            Na odpowiedź mamy do 14 dni roboczych (lub dłużej, jeśli o tym
            poinformujemy).
          </li>
          <li>Dostępne są też pozasądowe sposoby rozwiązywania sporów.</li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuły 10-11 – Rozwiązanie/odstąpienie
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Możesz rozwiązać umowę o korzystanie z serwisu (usunięcie konta) –
            przez kontakt.
          </li>
          <li>
            Dane z zrealizowanych umów przechowujemy przez okres wymagany prawem
            (co do zasady 5 lat).
          </li>
          <li>Po usunięciu konta nie zalogujesz się poprzednimi danymi.</li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 12 – Zmiany regulaminu
        </h4>
        <p>
          Informujemy o zmianach; brak akceptacji = brak możliwości dalszego
          korzystania.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 13 – Płatności
        </h4>
        <p>
          Określamy operatorów płatności i rodzaje instrumentów; zwroty i
          reklamacje online są obsługiwane zgodnie z procedurą operatora i
          Regulaminem.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 14 – Postanowienia końcowe
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            Działamy zgodnie z prawem polskim; spory rozstrzygają właściwe sądy
            powszechne w Polsce.
          </li>
          <li>
            Wersją wiążącą jest Regulamin w języku polskim (z tłumaczeniem na
            angielski dla wygody).
          </li>
        </ul>

        <p className="mt-4">
          Aby zapoznać się z pełnym brzmieniem Regulaminu i Polityki
          Prywatności, przejdź do odpowiednich stron w serwisie WeExpert.
        </p>
      </div>
      <div className="space-y-6">
        <h3 className="text-xl font-semibold mt-10 mb-4">
          Regulamin serwisu WeExpert
        </h3>
        <p>
          Staraliśmy się spisać zasady w możliwie prosty sposób. Skróconą wersję
          Regulaminu znajdziesz w naszym Centrum Pomocy.
        </p>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 1 – Definicje
        </h4>
        <ul className="list-disc list-inside space-y-2 ml-4">
          <li>
            <strong>Administrator, WeExpert</strong> – WeExpert (podmiot
            prowadzący Serwis dostępny pod adresem www.weexpert.io); kontakt:
            info@weexpert.io.
          </li>
          <li>
            <strong>Serwis WeExpert/Serwis</strong> – otwarty serwis
            transakcyjny online służący publikowaniu Ogłoszeń, zawieraniu umów
            dotyczących wykonania usług oraz komunikacji między stronami
            transakcji; dostępny w domenie weexpert.io.
          </li>
          <li>
            <strong>Zlecenie</strong> – zaakceptowany przez Freelancera i
            Zleceniodawcę zakres prac wynikający z Ogłoszenia i przyjęty do
            realizacji.
          </li>
          <li>
            <strong>Umowa</strong> – ustalenia między Użytkownikami oraz
            Użytkownikami a Administratorem dotyczące realizacji Zlecenia (w tym
            postanowienia Regulaminu).
          </li>
          <li>
            <strong>Dzieło</strong> – efekt czynności wykonanych przez
            Freelancera zgodnie z przyjętym Zleceniem.
          </li>
          <li>
            <strong>Użytkownik</strong> – osoba fizyczna mająca pełną zdolność
            do czynności prawnych (lub działająca za zgodą opiekuna), osoba
            prawna lub jednostka organizacyjna bez osobowości prawnej, która
            korzysta z usług WeExpert (w roli Zleceniodawcy lub Freelancera).
          </li>
          <li>
            <strong>Freelancer</strong> – Wykonawca prezentujący w Serwisie
            możliwość wykonania usług/czynności/dzieł lub składający oferty ich
            wykonania.
          </li>
          <li>
            <strong>Freelancer Krajowy</strong> – polski rezydent podatkowy.
          </li>
          <li>
            <strong>Freelancer Zagraniczny</strong> – nierezydent podatkowy RP.
          </li>
          <li>
            <strong>Zleceniodawca</strong> – Użytkownik publikujący Ogłoszenie
            lub składający propozycję Zlecenia.
          </li>
          <li>
            <strong>Podmiot powiązany</strong> – spółka/spółki z grupy WeExpert
            lub inni wskazani partnerzy, którym Administrator może powierzyć
            część czynności (np. archiwizacja dokumentów, obsługa praw
            autorskich, usługi KYC/AML).
          </li>
          <li>
            <strong>
              Umowa o przeniesienie majątkowych praw autorskich / umowa
              licencyjna
            </strong>{" "}
            – ustalenia Stron dotyczące przeniesienia praw majątkowych, praw
            zależnych lub udzielenia licencji niewyłącznej do przedmiotu
            Zlecenia.
          </li>
          <li>
            <strong>Konto</strong> – zindywidualizowany zapis w Serwisie,
            chroniony loginem i hasłem.
          </li>
          <li>
            <strong>Płatności Online</strong> – usługa płatności internetowych
            realizowana przez zewnętrznego operatora płatności wskazanego w
            Serwisie (dalej: Dostawca Płatności Online).
          </li>
        </ul>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 2 – Postanowienia ogólne
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Regulamin określa zasady świadczenia przez WeExpert odpłatnych usług
            elektronicznych polegających na kojarzeniu Użytkowników
            (Zleceniodawców i Freelancerów), rozliczaniu transakcji, korzystaniu
            z Serwisu oraz świadczeniu usług dodatkowych.
          </li>
          <li>
            WeExpert ułatwia wyszukiwanie Zleceniodawców/Freelancerów oraz
            umożliwia rozliczenie i komunikację w Serwisie.
          </li>
          <li>
            WeExpert jest dostawcą platformy pośredniczącej; nie realizuje
            usług/dzieł, nie prowadzi negocjacji, nie odpowiada za ich
            wykonanie.
          </li>
          <li>
            WeExpert może powierzać czynności podmiotom trzecim/powiązanym. W
            takiej sytuacji rozliczającym może być wskazany podmiot trzeci.
          </li>
          <li>
            Warunkiem pełnego korzystania z Serwisu jest złożenie
            elektronicznych oświadczeń o: (i) akceptacji Regulaminu, (ii)
            akceptacji konstrukcji praw i obowiązków między Użytkownikami oraz
            podmiotami powiązanymi, (iii) zapoznaniu się z Polityką Prywatności.
            Zaznaczenie checkboxów/zwrotne potwierdzenie e-mail jest
            równoznaczne ze złożeniem oświadczeń.
          </li>
          <li>
            Odpowiedzialność stron: Zleceniodawca przyjmuje do wiadomości, że za
            wykonanie Zlecenia odpowiada wyłącznie Freelancer. WeExpert może
            udostępnić Zleceniodawcy dane Freelancera w celu dochodzenia
            roszczeń.
          </li>
          <li>
            Freelancer oświadcza, że posiada wymagane uprawnienia/licencje do
            realizacji Zlecenia (jeśli prawo ich wymaga) i ponosi
            odpowiedzialność za ich brak.
          </li>
          <li>
            Wszelka komunikacja między Użytkownikami (dotycząca Ogłoszeń/Zleceń)
            odbywa się poprzez komunikator w Serwisie.
          </li>
          <li>
            Rozliczanie transakcji poza Serwisem po skojarzeniu w Serwisie jest
            zakazane i może skutkować odszkodowaniem na rzecz Administratora
            oraz blokadą Konta.
          </li>
          <li>
            Niedozwolone jest używanie cudzych kart/kont/rachunków do rozliczeń.
          </li>
          <li>Zakaz spamu i niezamówionej informacji handlowej.</li>
          <li>
            Freelancer oświadcza, że realizuje Zlecenia zgodnie z prawem, w tym
            w zakresie ochrony danych i praw własności intelektualnej.
          </li>
          <li>
            W przypadku przeniesienia praw/udzielenia licencji – obowiązują
            postanowienia Artykułu 7.
          </li>
          <li>
            WeExpert komunikuje się z Użytkownikami przez komunikator w Serwisie
            lub e-mail podany na Koncie.
          </li>
          <li>
            Wymagania techniczne: dostęp do Internetu; urządzenie z możliwością
            wprowadzania/odczytu danych; możliwość odczytu plików
            PDF/RTF/TXT/DOC/JPEG/AVI; aktualna przeglądarka
            (Chrome/Firefox/Edge) z włączonym JavaScriptem i cookies.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 3 – Rejestracja
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>Pełna funkcjonalność Serwisu wymaga rejestracji.</li>
          <li>
            Osoby prawne i jednostki organizacyjne rejestruje osoba należycie
            umocowana.
          </li>
          <li>
            Rejestracja odbywa się poprzez formularz i akceptację Regulaminu.
          </li>
          <li>
            Aktywacja Konta (potwierdzona e-mailem) oznacza zawarcie umowy o
            świadczenie usług w Serwisie.
          </li>
          <li>
            Konsument może odstąpić od umowy w 14 dni (z zastrzeżeniami w
            Artykule 16).
          </li>
          <li>Administrator może żądać udokumentowania danych.</li>
          <li>
            Dane publiczne: dla osób fizycznych – imię i nazwisko oraz
            miejscowość; dla firm – firma i miejscowość siedziby; dla
            Freelancerów – co najmniej 1 przykład pracy.
          </li>
          <li>Zmiany danych należy niezwłocznie aktualizować w profilu.</li>
          <li>
            Zakazane: podawanie nieprawdziwych danych, usuwanie wymaganych
            danych, dublowanie Kont Freelancera.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 4 – Prawa autorskie
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Jeśli wykonanie Zlecenia skutkuje powstaniem utworu, Strony stosują
            mechanizm przeniesienia praw lub licencji zgodnie z niniejszym
            Artykułem.
          </li>
          <li>
            Model łańcuchowy (pośrednictwo):
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                Freelancer zawiera warunkową umowę o przeniesienie majątkowych
                praw autorskich (oraz prawa do zezwoleń na prawa zależne) na
                Podmiot powiązany – warunkiem jest akceptacja Zlecenia przez
                Zleceniodawcę.
              </li>
              <li>
                Podmiot powiązany przenosi nabyte prawa na Administratora
                (WeExpert) w chwili akceptacji Zlecenia.
              </li>
              <li>
                Administrator przenosi majątkowe prawa autorskie na
                Zleceniodawcę na mocy umowy o przeniesienie (wysyłanej po
                akceptacji Dzieła) albo Zleceniodawca otrzymuje licencję
                niewyłączną (zgodnie z wyborem w formularzu).
              </li>
            </ul>
          </li>
          <li>
            Przeniesienie praw nie jest ograniczone co do celu, czasu i
            terytorium; następuje nieodpłatnie (wynagrodzenie zawiera się w
            wynagrodzeniu za Zlecenie).
          </li>
          <li>
            Pola eksploatacji przy przeniesieniu obejmują m.in.:
            utrwalanie/zwielokrotnianie dowolną techniką, użyczenie/najem,
            publiczne rozpowszechnianie, udostępnianie online,
            nadawanie/reemisję, wprowadzanie do pamięci komputera,
            Internet/intranet, opracowania i modyfikacje; oraz – dla programów i
            serwisów – zwielokrotnianie kodu, tłumaczenie formy (dekompilacja) w
            zakresie dozwolonym, opracowania i modyfikacje.
          </li>
          <li>
            Pola eksploatacji obejmują również wszystkie elementy składające się
            na Dzieło.
          </li>
        </ol>
      </div>

      <div className="space-y-6">
        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 4a – Przeniesienie majątkowych praw autorskich
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Freelancer przenosi prawa na Podmiot powiązany pod warunkiem
            akceptacji Zlecenia.
          </li>
          <li>
            Podmiot powiązany przenosi prawa na Administratora, a Administrator
            – na Zleceniodawcę (moment: podpisanie umowy przeniesienia przez
            Strony i akceptacja Zlecenia).
          </li>
          <li>Zakres pól eksploatacji jak wyżej.</li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 4b – Licencje
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Jeśli wybrano licencję – Freelancer udziela Zleceniodawcy licencji
            niewyłącznej, z prawem do sublicencji, na okres 15 lat, z szerokim
            zakresem pól eksploatacji (utrwalanie/zwielokrotnianie, wprowadzanie
            do obrotu, użyczenie/najem, publiczne wykonanie/udostępnianie
            online, sieci telekomunikacyjne, publikacje, banki utworów,
            on-demand, łączenie z innymi utworami, nadawanie, wydania zbiorowe,
            a dla programów – modyfikacje i opracowania).
          </li>
          <li>Licencja obejmuje zgodę na utwory zależne (prawa zależne).</li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">Artykuł 5 – Opłaty</h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>Część usług w Serwisie jest płatna.</li>
          <li>
            Podstawową opłatą jest prowizja Administratora (zgodnie z
            Załącznikiem nr 3 – Cennik).
          </li>
          <li>Firmy-Freelancerzy mogą wykupić abonament na składanie ofert.</li>
          <li>
            Pozostałe opłaty (np. płatności online, wysyłka dokumentów, wybór
            trybu rozliczenia) określa cennik.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 6 – Inne postanowienia
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            WeExpert nie odpowiada za działania Użytkowników, rzetelność danych
            i ich zdolność do zawierania/realizacji umów.
          </li>
          <li>
            WeExpert może usunąć Ogłoszenie/Zlecenie lub zablokować Konto przy
            naruszeniu prawa/Regulaminu/dobrych obyczajów; Zlecenia zostaną
            oznaczone jako „Sporne”.
          </li>
          <li>
            W razie blokady Konta Ogłoszenia są usuwane; Użytkownik traci dostęp
            do usług.
          </li>
          <li>
            Odwołania od blokady: info@weexpert.io (z danymi identyfikującymi
            Konto i materiałami). Termin rozpatrzenia: do 7 dni.
          </li>
          <li>
            Zakaz treści bezprawnych w Ogłoszeniach/Zleceniach (m.in.
            obraźliwych, wprowadzających w błąd, naruszających prawa IP, czyny
            nieuczciwej konkurencji).
          </li>
          <li>
            WeExpert może prezentować logotyp/nazwę Użytkownika (np. w sekcji
            „Nasi klienci”) oraz dane zbiorcze (profil, liczba zleceń) – w
            celach informacyjnych i promocyjnych.
          </li>
          <li>
            Wysyłka dokumentów pocztą (jeśli zamówiona) – w terminie do 5 dni od
            opłacenia usługi.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 7 – Umowy sporne
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            WeExpert nie odpowiada za niewykonanie/nienależyte wykonanie przez
            Użytkowników; w ramach wsparcia proponuje formy rozwiązania sporu.
          </li>
          <li>
            Podstawą weryfikacji jest zgodność pliku/dokumentu z tytułem i
            opisem zlecenia oraz (pomocniczo) treści z komunikatora w Serwisie.
          </li>
          <li>Nie bierzemy pod uwagę ustaleń poza Serwisem.</li>
          <li>Nie oceniamy jakości merytorycznej/estetycznej/funkcjonalnej.</li>
          <li>
            Gdy nie da się rozstrzygnąć – proponujemy: (a) poprawki
            (zakres/termin uzgadniają Strony), (b) zmianę stawki, (c) wypłatę
            50/50.
          </li>
          <li>
            Strony mają 7 dni na jednomyślną decyzję i informują nas mailowo
            (info@weexpert.io).
          </li>
          <li>
            Brak decyzji → rozliczenie 50/50 i udostępnienie dokumentacji
            Stronom (dla ewentualnej drogi sądowej).
          </li>
          <li>
            Strony mogą wybrać mediatora/rzeczoznawcę (na własny koszt);
            Administrator może zabezpieczyć płatność do czasu rozstrzygnięcia.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 8 – Postępowanie reklamacyjne
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Reklamacje usług WeExpert: w terminie 7 dni od zakończenia
            publikacji Ogłoszenia lub realizacji Zlecenia (lub od zdarzenia).
          </li>
          <li>
            Zgłoszenie: info@weexpert.io lub pocztą na adres korespondencyjny
            Administratora wskazany w Serwisie (o terminie decyduje data
            nadania).
          </li>
          <li>
            Reklamacja powinna zawierać dane Użytkownika, numer
            Ogłoszenia/Zlecenia (lub dane identyfikacyjne zdarzenia) i
            okoliczności/materiały.
          </li>
          <li>
            Rozpatrzenie: niezwłocznie, maks. 10 dni roboczych od otrzymania
            kompletu informacji (możliwa prośba o uzupełnienie).
          </li>
          <li>O wyniku informujemy e-mailem.</li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 9 – Pozasądowe sposoby rozpatrywania reklamacji i dochodzenia
          roszczeń
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Skorzystanie jest dobrowolne; informacje mają charakter poglądowy.
          </li>
          <li>
            Zasady określa ustawa z 23.09.2016 r. o pozasądowym rozwiązywaniu
            sporów konsumenckich; rejestr podmiotów prowadzi Prezes UOKiK.
          </li>
          <li>
            Konsument może m.in.:
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                wnieść sprawę do stałego polubownego sądu konsumenckiego (art.
                37 ustawy o Inspekcji Handlowej),
              </li>
              <li>
                wnioskować do wojewódzkiego inspektora IH o pozasądowe
                rozwiązanie sporu,
              </li>
              <li>
                skorzystać z pomocy miejskiego/powiatowego rzecznika konsumentów
                lub organizacji konsumenckich.
              </li>
            </ul>
          </li>
          <li>
            Szczegóły: strony UOKiK oraz właściwych rzeczników/inspektoratów.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 10 – Rozwiązanie umowy
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Umowa o świadczenie usług w Serwisie jest zawarta na czas
            nieoznaczony (język polski).
          </li>
          <li>
            Użytkownik może rozwiązać umowę w każdym czasie – e-mailem na
            info@weexpert.io lub listownie (adres korespondencyjny w Serwisie).
          </li>
          <li>
            Skutek natychmiastowy, chyba że są aktywne Ogłoszenia lub trwają
            Zlecenia – wtedy po 30 dniach od ich zakończenia.
          </li>
          <li>
            Administrator może rozwiązać umowę w razie naruszeń Regulaminu.
          </li>
        </ol>
      </div>
      <div className="space-y-6">
        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 11 – Odstąpienie od umowy
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Konsument ma prawo odstąpić w 14 dni bez podania przyczyn (na
            zasadach ustawowych).
          </li>
          <li>
            Odstąpienie: oświadczenie e-mailem na info@weexpert.io lub listownie
            (adres korespondencyjny w Serwisie).
          </li>
          <li>Termin biegnie od dnia zawarcia umowy.</li>
          <li>
            Brak prawa odstąpienia, m.in. gdy:
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                usługa została w pełni wykonana za wyraźną zgodą konsumenta
                poinformowanego o utracie prawa,
              </li>
              <li>
                dostarczanie treści cyfrowych niezapisanych na nośniku
                rozpoczęło się za wyraźną zgodą przed upływem terminu i po
                poinformowaniu o utracie prawa.
              </li>
            </ul>
          </li>
          <li>
            „Konsument” obejmuje również inne osoby, do których stosuje się
            przepisy o konsumentach.
          </li>
          <li>
            Wzory pouczenia i formularza – Załącznik nr 1 i Załącznik nr 2.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 12 – Zmiany Regulaminu
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            WeExpert może zmienić Regulamin i uruchomić nową wersję usług.
            Zmiany wchodzą w życie nie wcześniej niż po 7 dniach od publikacji i
            udostępnienia w Serwisie do akceptacji.
          </li>
          <li>
            Ogłoszenia/Zlecenia opublikowane przed wejściem zmian realizowane są
            na dotychczasowych zasadach.
          </li>
          <li>
            Odmowa akceptacji zmian = rozwiązanie umowy ramowej z WeExpert.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 13 – Płatności Online
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Płatności Online obsługuje Dostawca Płatności Online wskazany w
            Serwisie.
          </li>
          <li>
            Dostępne formy płatności obejmują karty płatnicze (np. Visa,
            Mastercard) oraz inne metody udostępnione przez Dostawcę.
          </li>
          <li>
            Zwroty transakcji kartowych są kierowane na rachunek przypisany do
            karty Użytkownika (zgodnie z zasadami Dostawcy).
          </li>
          <li>
            Czas realizacji zamówienia liczy się od pozytywnej autoryzacji
            płatności.
          </li>
          <li>
            Użytkownik korzystający z Płatności Online oświadcza, że zapoznał
            się z regulaminem i polityką prywatności Dostawcy Płatności Online.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">
          Artykuł 14 – Końcowe postanowienia
        </h4>
        <ol className="list-decimal list-inside space-y-2 ml-4">
          <li>
            Prawem właściwym dla usług świadczonych w Serwisie i relacji
            Użytkownik–WeExpert jest prawo polskie.
          </li>
          <li>
            Prawem właściwym dla relacji Zleceniodawca–Freelancer (zawieranych
            przez Serwis) jest prawo polskie (za zgodą Stron).
          </li>
          <li>
            Wszelkie spory dotyczące usług WeExpert rozstrzygają właściwe sądy
            powszechne w Polsce.
          </li>
          <li>
            W razie rozbieżności wersji językowych – wiążąca jest wersja polska
            (a w razie jej braku – wersja angielska).
          </li>
          <li>
            Nieważność pojedynczego postanowienia nie wpływa na ważność
            pozostałych; w miejsce nieważnego wchodzi postanowienie najbliższe
            zamiarowi Stron.
          </li>
          <li>
            Integralną częścią Regulaminu są załączniki: cennik, pouczenie o
            odstąpieniu, formularz odstąpienia.
          </li>
          <li>
            Rozliczenia transakcji kartą i e-przelewem są realizowane przez
            Dostawcę Płatności Online.
          </li>
        </ol>

        <h4 className="text-lg font-semibold mt-6 mb-2">Załączniki</h4>
        <ul className="list-disc list-inside space-y-1 ml-6">
          <li>
            Załącznik nr 1 – Wzór pouczenia o odstąpieniu od umowy (standardowe
            pouczenie zgodne z art. 13 ustawy o prawach konsumenta – do
            wstawienia w docelowej publikacji)
          </li>
          <li>
            Załącznik nr 2 – Wzór formularza odstąpienia od umowy (standardowy
            wzór z art. 30 ust. 1 ustawy o prawach konsumenta – do wstawienia w
            docelowej publikacji)
          </li>
          <li>
            Załącznik nr 3 – Cennik (Aktualny cennik opłat i prowizji
            publikowany w Serwisie; zawiera m.in. stawki prowizji, opłaty
            minimalne/maksymalne, opłaty dodatkowe, warunki abonamentów)
          </li>
        </ul>

        <p className="mt-4">
          Kontakt w sprawach Regulaminu i reklamacji:{" "}
          <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
            info@weexpert.io
          </a>
          .
        </p>
        <p>
          Adres korespondencyjny Administratora – zgodnie z informacją
          opublikowaną w Serwisie.
        </p>
      </div>

      <div className="space-y-6">
        <h4 className="text-lg font-semibold mt-6 mb-2">
          Polityka plików cookies WeExpert
        </h4>
        <p>
          Niniejsza Polityka plików cookies wyjaśnia, w jaki sposób i w jakim
          celu WeExpert (operator serwisu dostępnego pod adresem{" "}
          <a href="https://weexpert.io" className="text-blue-600 underline">
            weexpert.io
          </a>
          , dalej: „My”, „Serwis”) korzysta z plików cookies własnych oraz
          zaufanych partnerów, a także podobnych technologii. Opisujemy również,
          jak możesz zarządzać swoimi zgodami i ustawieniami.
        </p>
        <p>
          Kontakt w sprawach cookies i prywatności:{" "}
          <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
            info@weexpert.io
          </a>
          .
        </p>
        <p>
          Zasady przetwarzania danych osobowych znajdziesz w naszej Polityce
          prywatności.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          1) Czym są pliki cookies i podobne technologie?
        </h5>
        <p>
          Cookies to małe pliki zapisywane na Twoim urządzeniu (komputerze,
          tablecie, smartfonie) przez przeglądarkę. Pozwalają rozpoznać Twoją
          przeglądarkę, zapamiętać wybrane ustawienia oraz zbierać zagregowane
          informacje o korzystaniu z Serwisu (np. adres IP, typ przeglądarki,
          czas spędzony na stronie, odwiedzone podstrony, adres URL odsyłający).
        </p>
        <p>
          Podobne technologie to m.in. local storage, piksele śledzące, SDK w
          aplikacjach, tagi.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          2) Jakie rodzaje cookies wykorzystujemy?
        </h5>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            <strong>techniczne/niezbędne (bez zgody)</strong> – konieczne do
            prawidłowego działania Serwisu (logowanie, bezpieczeństwo,
            formularze);
          </li>
          <li>
            <strong>funkcjonalne (za zgodą)</strong> – zapamiętują Twoje
            preferencje (np. język, tryb wyglądu);
          </li>
          <li>
            <strong>analityczne (za zgodą)</strong> – pomagają zrozumieć, jak
            korzystasz z Serwisu i ulepszać go (statystyki, błędy);
          </li>
          <li>
            <strong>marketingowe i promocyjne/reklamowe (za zgodą)</strong> –
            pozwalają wyświetlać treści i reklamy dopasowane do zainteresowań
            oraz mierzyć skuteczność kampanii;
          </li>
          <li>
            <strong>inne/nieklasyfikowane (za zgodą)</strong> – tymczasowa
            kategoria dla nowych narzędzi do momentu pełnej klasyfikacji.
          </li>
        </ul>
        <p>Cookies dzielą się także na:</p>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            <strong>sesyjne</strong> – usuwane po zamknięciu przeglądarki,
          </li>
          <li>
            <strong>trwałe</strong> – przechowywane przez określony czas.
          </li>
        </ul>

        <h5 className="text-md font-semibold mt-4 mb-2">
          3) Czy korzystamy z cookies podmiotów trzecich?
        </h5>
        <p>
          Tak. Współpracujemy z zaufanymi partnerami, którzy mogą umieszczać
          własne cookies lub korzystać z naszych. Lista typowych partnerów wraz
          z ich politykami prywatności:
        </p>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            <strong>Analityczne</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                Google (Analytics 4, Tag Manager) –{" "}
                <a
                  href="https://policies.google.com/privacy"
                  className="text-blue-600 underline"
                >
                  policies.google.com/privacy
                </a>
              </li>
              <li>
                Hotjar –{" "}
                <a
                  href="https://www.hotjar.com/legal/policies/privacy"
                  className="text-blue-600 underline"
                >
                  hotjar.com/legal/policies/privacy
                </a>
              </li>
              <li>
                New Relic –{" "}
                <a
                  href="https://newrelic.com/termsandconditions/privacy"
                  className="text-blue-600 underline"
                >
                  newrelic.com/termsandconditions/privacy
                </a>
              </li>
            </ul>
          </li>
          <li>
            <strong>Promocyjne/Marketingowe</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                Meta (Facebook/Instagram) –{" "}
                <a
                  href="https://www.facebook.com/policy.php"
                  className="text-blue-600 underline"
                >
                  facebook.com/policy.php
                </a>
              </li>
              <li>
                LinkedIn –{" "}
                <a
                  href="https://www.linkedin.com/legal/l/cookie-table"
                  className="text-blue-600 underline"
                >
                  linkedin.com/legal/l/cookie-table
                </a>
              </li>
              <li>
                YouTube –{" "}
                <a
                  href="https://policies.google.com/technologies/cookies"
                  className="text-blue-600 underline"
                >
                  policies.google.com/technologies/cookies
                </a>
              </li>
            </ul>
          </li>
          <li>
            <strong>Funkcjonalne/Operacyjne</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                HubSpot –{" "}
                <a
                  href="https://legal.hubspot.com/privacy-policy"
                  className="text-blue-600 underline"
                >
                  legal.hubspot.com/privacy-policy
                </a>
              </li>
              <li>
                Trustpilot –{" "}
                <a
                  href="https://legal.trustpilot.com/for-businesses/business-privacy-policy"
                  className="text-blue-600 underline"
                >
                  legal.trustpilot.com/for-businesses/business-privacy-policy
                </a>
              </li>
              <li>
                Mailjet –{" "}
                <a
                  href="https://www.mailjet.com/legal/privacy-policy"
                  className="text-blue-600 underline"
                >
                  mailjet.com/legal/privacy-policy
                </a>
              </li>
              <li>
                SEON –{" "}
                <a
                  href="https://seon.io/resources/legal-and-security/privacy"
                  className="text-blue-600 underline"
                >
                  seon.io/resources/legal-and-security/privacy
                </a>
              </li>
              <li>
                Amazon Web Services –{" "}
                <a
                  href="https://aws.amazon.com/privacy"
                  className="text-blue-600 underline"
                >
                  aws.amazon.com/privacy
                </a>
              </li>
              <li>
                JetBrains –{" "}
                <a
                  href="https://www.jetbrains.com/privacy-security"
                  className="text-blue-600 underline"
                >
                  jetbrains.com/privacy-security
                </a>
              </li>
              <li>
                Surfer –{" "}
                <a
                  href="https://surferseo.com/privacy-policy"
                  className="text-blue-600 underline"
                >
                  surferseo.com/privacy-policy
                </a>
              </li>
              <li>
                Brand24 –{" "}
                <a
                  href="https://brand24.pl/polityka-prywatnosci"
                  className="text-blue-600 underline"
                >
                  brand24.pl/polityka-prywatnosci
                </a>
              </li>
            </ul>
          </li>
        </ul>
        <p>
          Uwaga: zestaw partnerów może zmieniać się w czasie. Aktualną listę
          dostawców oraz szczegóły znajdziesz w banerze zgód (CMP) oraz w tabeli
          cookies w stopce lub ustawieniach prywatności w Serwisie.
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          4) Jak korzystamy z cookies?
        </h5>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>uwierzytelniać użytkowników i ułatwiać nawigację;</li>
          <li>
            zabezpieczać Serwis przed nadużyciami i atakami (np. mechanizmy
            anty-bot);
          </li>
          <li>
            rozumieć sposób korzystania z Serwisu (statystyki, wydajność,
            błędy);
          </li>
          <li>personalizować treści i komunikaty;</li>
          <li>
            prowadzić marketing własnych usług na stronach partnerów oraz
            mierzyć efekty kampanii.
          </li>
        </ul>

        <h5 className="text-md font-semibold mt-4 mb-2">
          5) Kategorie i przykładowe cookies
        </h5>
        <p>
          Poniżej przykład typowych nazw/źródeł. Rzeczywista, aktualna lista
          jest dostępna w naszym menedżerze zgód (CMP).
        </p>
        <ul className="list-disc list-inside ml-6 space-y-2">
          <li>
            <strong>A. Techniczne (niezbędne – bez zgody)</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                CookieConsent (weexpert.io) – zapamiętuje wybory zgód, do 1 roku
              </li>
              <li>
                csrftoken (weexpert.io) – zabezpieczenie formularzy, do 1 roku
              </li>
              <li>
                __cf_bm, __cfruid (poddostawcy wsparcia/centrum pomocy, np.
                help.weexpert.io) – ochrona i wydajność, sesyjne/krótkotrwałe
              </li>
              <li>rc::a, rc::c (gstatic.com) – anty-bot, trwałe/sesyjne</li>
            </ul>
          </li>
          <li>
            <strong>B. Funkcjonalne (za zgodą)</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                chakra-ui-color-mode (weexpert.io) – preferencje wyglądu (np.
                dark mode), trwałe
              </li>
              <li>
                ZD-store, ZD-settings (dostawca help desk, np.
                static.zdassets.com) – ustawienia centrum pomocy, trwałe/sesyjne
              </li>
            </ul>
          </li>
          <li>
            <strong>C. Analityczne (za zgodą)</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                _ga, _ga_*, _gid, _gat (weexpert.io / Google Analytics) –
                statystyki użytkowania, 1 dzień–2 lata
              </li>
              <li>
                _hj* (weexpert.io / Hotjar) – mapy zachowań/sesji,
                sesyjne/krótkotrwałe
              </li>
              <li>
                identyfikatory diagnostyczne wydajności (np. New Relic) – czasy
                odpowiedzi, błędy
              </li>
            </ul>
          </li>
          <li>
            <strong>D. Marketing/Promocja (za zgodą)</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                _fbp (weexpert.io / Meta) – pomiar kampanii, ok. 3 miesiące
              </li>
              <li>
                _gcl_au, ads/* (Google Ads/Tag Manager) – atrybucja reklam,
                sesyjne/krótkotrwałe
              </li>
              <li>
                VISITOR_INFO1_LIVE, YSC (YouTube) – odtwarzanie i statystyki
                wideo, sesyjne/okresowe
              </li>
            </ul>
          </li>
          <li>
            <strong>E. Nieklasyfikowane (za zgodą)</strong>
            <ul className="list-disc list-inside ml-6 space-y-1">
              <li>
                nowe/testowe cookies – do czasu pełnej klasyfikacji oznaczane
                jako „inne”
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="space-y-6">
        <h5 className="text-md font-semibold mt-4 mb-2">
          6) Czy cookies przechowują dane osobowe?
        </h5>
        <p>
          Same cookies zazwyczaj nie identyfikują Cię bezpośrednio. Jednak w
          połączeniu z informacjami podanymi np. przy rejestracji, niektóre dane
          mogą stać się danymi osobowymi. Zasady ich przetwarzania, podstawy
          prawne i Twoje prawa opisuje Polityka prywatności. W każdej chwili
          możesz:
        </p>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>wyrazić/wycofać zgody w banerze zgód (CMP),</li>
          <li>sprzeciwić się przetwarzaniu do celów marketingowych (RODO),</li>
          <li>
            zażądać dostępu, sprostowania, usunięcia itp. – kontakt:{" "}
            <a
              href="mailto:info@weexpert.io"
              className="text-blue-600 underline"
            >
              info@weexpert.io
            </a>
            .
          </li>
        </ul>

        <h5 className="text-md font-semibold mt-4 mb-2">
          7) Jak zarządzać cookies?
        </h5>
        <p>
          <strong>A. Przez nasz baner zgód (CMP)</strong>
          <br />
          Kliknij „Ustawienia prywatności”/„Zarządzaj cookies” w stopce Serwisu
          – tam włączysz/wyłączysz kategorie (poza niezbędnymi).
        </p>
        <p>
          <strong>B. W przeglądarce</strong>
          <br />
          Możesz zablokować lub usunąć cookies w ustawieniach przeglądarki
          (zwykle „Opcje”/„Preferencje”). Przydatne instrukcje:
        </p>
        <ul className="list-disc list-inside ml-6 space-y-1">
          <li>
            Chrome –{" "}
            <a
              href="https://support.google.com/chrome/answer/95647"
              className="text-blue-600 underline"
            >
              support.google.com/chrome/answer/95647
            </a>
          </li>
          <li>
            Firefox –{" "}
            <a
              href="https://support.mozilla.org/pl/kb/usuwanie-ciasteczek-i-danych-stron-firefox"
              className="text-blue-600 underline"
            >
              support.mozilla.org/pl/kb/usuwanie-ciasteczek-i-danych-stron-firefox
            </a>
          </li>
          <li>
            Opera –{" "}
            <a
              href="https://help.opera.com/pl/latest/web-preferences/#cookies"
              className="text-blue-600 underline"
            >
              help.opera.com/pl/latest/web-preferences/#cookies
            </a>
          </li>
          <li>
            Microsoft Edge –{" "}
            <a
              href="https://support.microsoft.com/pl-pl/microsoft-edge/..."
              className="text-blue-600 underline"
            >
              support.microsoft.com/pl-pl/microsoft-edge/...
            </a>
          </li>
          <li>
            Safari –{" "}
            <a
              href="https://support.apple.com/pl-pl/guide/safari/sfri11471/mac"
              className="text-blue-600 underline"
            >
              support.apple.com/pl-pl/guide/safari/sfri11471/mac
            </a>
          </li>
        </ul>
        <p>
          Na urządzeniach mobilnych skorzystaj z instrukcji producenta.
          Dodatkowo możesz zarządzać reklamą behawioralną przez{" "}
          <a
            href="https://www.youronlinechoices.com/pl"
            className="text-blue-600 underline"
          >
            Your Online Choices
          </a>
          .
        </p>
        <p>
          Uwaga: usunięcie cookies nie oznacza automatycznego usunięcia danych
          osobowych, które przetwarzamy na innej podstawie. Swoje prawa
          dotyczące danych zrealizujesz zgodnie z Polityką prywatności (kontakt:{" "}
          <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
            info@weexpert.io
          </a>
          ).
        </p>

        <h5 className="text-md font-semibold mt-4 mb-2">
          8) Zmiany w Polityce cookies
        </h5>
        <p>
          Możemy aktualizować niniejszą Politykę (np. przy zmianie
          technologii/partnerów). Nowa wersja będzie publikowana w Serwisie i
          obowiązuje od dnia publikacji. W przypadku istotnych zmian poprosimy
          ponownie o Twoje zgody w banerze.
        </p>
        <p>Data ostatniej aktualizacji: [wstaw datę publikacji]</p>
        <p>
          WeExpert – kontakt w sprawach cookies i prywatności:{" "}
          <a href="mailto:info@weexpert.io" className="text-blue-600 underline">
            info@weexpert.io
          </a>
          .
        </p>
      </div>
    </div>
  );
};
